// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.mjs";
import * as CustomErrorConverter$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/errors/CustomErrorConverter.mjs";
import * as FareEstimateResultCmsEntityMapper$PorterinFeature from "../entity-mappers/FareEstimateResultCmsEntityMapper.mjs";
import * as FareEstimateResultOmsEntityMapper$PorterinFeature from "../entity-mappers/FareEstimateResultOmsEntityMapper.mjs";
import * as FareEstimateResultCallBackRequestEntityMapper$PorterinFeature from "../entity-mappers/FareEstimateResultCallBackRequestEntityMapper.mjs";

var execute = FareEstimateResultCmsEntityMapper$PorterinFeature.execute;

var CmsApiConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var CmsResponseConverter = partial_arg(CmsApiConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = FareEstimateResultOmsEntityMapper$PorterinFeature.execute;

var OmsApiConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var OmsResponseConverter = partial_arg$1(OmsApiConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = FareEstimateResultCallBackRequestEntityMapper$PorterinFeature.execute;

var FareEstimateResultCallBackRequestApiConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var FareEstimateResultCallBackRequestApiResponseConverter = partial_arg$2(FareEstimateResultCallBackRequestApiConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

function execute$3(json) {
  var data = JSON.parse(JSON.stringify(json));
  return data.exists;
}

var CustomerCheckExistStateMapper = {
  execute: execute$3
};

var execute$4 = execute$3;

var CustomerCheckExistApiConfig = {
  execute: execute$4
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var CustomerCheckExistApiResponseConverter = partial_arg$3(CustomerCheckExistApiConfig, {
      execute: CustomErrorConverter$PorterinUtils.execute
    });

export {
  CmsApiConfig ,
  CmsResponseConverter ,
  OmsApiConfig ,
  OmsResponseConverter ,
  FareEstimateResultCallBackRequestApiConfig ,
  FareEstimateResultCallBackRequestApiResponseConverter ,
  CustomerCheckExistStateMapper ,
  CustomerCheckExistApiConfig ,
  CustomerCheckExistApiResponseConverter ,
}
/* CmsResponseConverter Not a pure module */
